import React from 'react'
import {Badge, Media} from "reactstrap";
import dateHelpers from "../../helpers/DateHelper";
import constants from "../../shared/constants";
import paymentTypeHelpers from "../../helpers/PaymentTypeHelper";
import LocalizedStrings from "react-localization";
import {resource_strings} from "../../translations/resource_translations";
import numberHelpers from "../../helpers/NumberHelper";

const propTypes = {};

class TicketReportRow extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            ticket: props.ticket,
            currency: props.currency
        };
    }

    render() {
        return (
            <tr>
                <td style={{maxWidth: 400, overflowX: 'hidden'}} >
                    <span className="mb-0 text-sm">
                        {this.state.ticket && this.state.ticket.name ? this.state.ticket.name : "..."}
                    </span>
                </td>
                <td>
                    <span className="mb-0 text-sm">
                        <div>
                            <a href="#"
                               onClick={() => this.props.goToClient(this.state.ticket.student_id)}> {this.state.ticket && this.state.ticket.student ? this.state.ticket.student : ""}
                            </a>
                        </div>
                        {this.state.ticket.student_email &&
                            <div>
                                <small>
                                    {this.state.ticket && this.state.ticket.student_email ? this.state.ticket.student_email : ""}
                                </small>
                            </div>
                        }
                    </span>
                </td>
                <td>
                    {this.state.ticket && this.state.ticket.active === true ?
                        (
                            <Badge color="" className="badge-dot">
                                <i className="bg-success"/>
                                {this.props.strings.active}
                            </Badge>) :
                        (
                            <Badge color="" className="badge-dot mr-4">
                                <i className="bg-warning"/>
                                {this.props.strings.not_active}
                            </Badge>
                        )
                    }
                </td>
                <td>
                    <span className="mb-0 text-sm">
                        {this.getEnd()}
                    </span>
                </td>
                <td>
                    <span className="mb-0 text-sm">
                        {dateHelpers.formatDate(new Date(this.state.ticket.purchase_date))}
                    </span>
                </td>
                <td>
                    <span className="mb-0 text-sm">
                        {this.price()}
                    </span>
                </td>
                <td className="text-right align-content-end">
                    <span className="mb-0 text-sm">
                        {this.getPaymentMethod()}
                    </span>
                </td>
            </tr>
        )
    }

    price() {
        return `${this.state.currency} ${numberHelpers.formatPrice(this.state.ticket && this.state.ticket.price ? this.state.ticket.price : "0")}`
    }

    getPaymentMethod() {
        if (this.state.ticket != null && this.state.ticket.pt) {
            let pm = paymentTypeHelpers.paymentTypes().find(p => p.value === this.state.ticket.pt);

            if (pm === undefined) {
                pm = paymentTypeHelpers.paymentTypes()[7].label
            }

            return pm.label
        } else {
            return paymentTypeHelpers.paymentTypes()[7].label
        }
    }

    getEnd() {
        return this.state.ticket && this.state.ticket.valid ? dateHelpers.formatDate(new Date(this.state.ticket.valid)) : constants.unlimitedSymbol
    }
}

TicketReportRow.propTypes = propTypes;

export default TicketReportRow;